/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Land_Documents_Area_MissingInputs */

const vi_grower_land_documents_area_missing = /** @type {(inputs: Grower_Land_Documents_Area_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không xác định được vùng trồng để lưu giấy tờ đất. Hộ đã lưu, vui lòng mở lại vùng đó và tải giấy tờ lên.`)
};

/**

* @param {Grower_Land_Documents_Area_MissingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_land_documents_area_missing = /** @type {((inputs?: Grower_Land_Documents_Area_MissingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Land_Documents_Area_MissingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_land_documents_area_missing(inputs)
});